import { render } from "./CompanyTable.vue?vue&type=template&id=fc87a380&scoped=true"
import script from "./CompanyTable.vue?vue&type=script&lang=js"
export * from "./CompanyTable.vue?vue&type=script&lang=js"

import "./CompanyTable.vue?vue&type=style&index=0&id=fc87a380&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fc87a380"

export default script